import React, { useContext, useEffect, useMemo, useState } from "react";
import { restore, TraitContext, TraitStore } from "./store";
import { Page, pagesToResult, Question, Trait } from "./model";
import { LeadForm } from "./customer-form";
import { ResultView } from "./result-view";
import { Loading } from "../components/Loading";

function QuestionRender({page, index, question}:{page: number, index: number, question: Question}){
    const {dispatch} = useContext(TraitContext);
    return <div className="question">
        <p><b>{question.index})</b> {question.text}</p>
        <ul>
            {question.options.map(o => <li key={o.type}>
                <label><input type="radio" checked={question.selected == o.type} onClick={()=> dispatch({type: "answer", page, question: index, answer: o.type}) } /> {o.text}</label>
            </li>)}
        </ul>
    </div>
}

function PageRender(){
    const {state} = useContext(TraitContext);
    const page = state.pages?.[state.currentPage];
    return <div className="questions">
        {page.questions.map((q, i)=> <QuestionRender key={i} question={q} page={state.currentPage} index={i} />)}
    </div>
}



function PageNav(){
    const {state, dispatch} = useContext(TraitContext);
    const last = state.currentPage >= state.pages.length - 1;

    const page = state.pages?.[state.currentPage];
    const canGoForward = useMemo(()=>{
        const answered = page.questions.reduce((a, q) => a + (q.selected ? 1 : 0), 0) 
        return answered == page.questions.length
    }, [page?.questions])

    function finish(){
        const result = pagesToResult(state.pages);
        console.log(result)
        dispatch({type: "setResult", result})
    }

    return <>
        {/*Pages: {state.pages.length} {canGoForward ? 'ok' : '!ok'}<br />
        currentPage: {state.currentPage + 1}<br /> */}
        {state.currentPage > 0 && <button className="btn btn-primary me-2"  onClick={()=>{dispatch({type: "setPage", page: state.currentPage - 1})}}>Voltar</button>}
        {last && <button className={`btn btn-primary ${canGoForward ? '' : 'disabled'}`} onClick={finish}>Concluir</button>}
        {!last && <button className={`btn btn-primary ${canGoForward ? '' : 'disabled'}`} onClick={()=>{dispatch({type: "setPage", page: state.currentPage + 1})}}>Próxima</button>}
    </>
}

function TraitApp(){
    const {state, dispatch} = useContext(TraitContext);
    const [loadingSave, setLoading] = useState(true);

    useEffect(function(){
        (async() => {
            await restore(dispatch)
            setLoading(false);
        })()
    }, [])


    if(loadingSave){
        return <Loading />
    }


    /*return <>
        <LeadForm />
        <ResultView result={result} />
    </>*/

    if(state.lead)
        return <ResultView result={state.traitResult} />
    
    if(state.traitResult)
        return <LeadForm />

    return <div className="traits-form p-4">
        <h2>Questionário</h2>
        <h4>Etapa {state.currentPage + 1} de {state.pages.length}</h4>
        <p className="mb-5 text-center">Ao responder a este questionário, lembre-se de ser sincero e escolher as opções que melhor refletem quem você realmente é.</p>
        <PageRender />
        <PageNav />
    </div>
}




export function App(){
    return <TraitStore>
        <TraitApp />
    </TraitStore>
}